module.exports = new __parcel__URL__("demon-days.910965f1.jpg").toString();